module.exports = __webpack_public_path__ + "img/cover6.f60d19b8.png";